import { Box, Stack } from '@mui/material';

import { styled } from '@/theme/styled';

const Container = styled(Stack)(({ theme }) => ({
  background: theme.palette.background.subtle,
  position: 'relative',
  overflow: 'hidden',
  height: '100%',
}));

const AnimationWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 0,
}));

const Content = styled(Stack)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
}));

export { Container, AnimationWrapper, Content };
